(ns manage.ad-variant-preview.tiktok
  (:require ["@mui/material/Avatar$default" :as Avatar]
            ["@mui/material/Box$default" :as Box]
            ["@mui/material/Button$default" :as Button]
            ["@mui/material/IconButton$default" :as IconButton]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/SvgIcon$default" :as SvgIcon]
            ["@mui/material/Typography$default" :as Typography]
            ["src/svg/arrows/arrow-turn-up-right.svg$default" :as ArrowTurnUpRight]
            ["src/svg/editor/emoji/heart.svg$default" :as Heart]
            ["src/svg/inform/bubble-left.svg$default" :as BubbleLeft]
            ["src/svg/objects/bookmark.svg$default" :as Bookmark]
            ["src/svg/person/person-circle.svg$default" :as PersonCircle]
            [uix.core :refer [$ defui]]))

(defn get-value [components k]
  (let [{:keys [error value]} (or (get components k)
                                  {:error {:message [(str "Missing " (name k))]}})]
    (if error
      ($ Typography
         {:component "span"
          :sx #js {:color "red"}}
         (first (:message error)))
      value)))

(defui tiktok-wrapper [{:keys [width components children]}]
  ;; These elements are using px on purpose so they aren't dependent on our MUI theme
  ;; selection.
  ;; Using typical TikTok mobile dimensions and styling
  ;;
  ;; AI generated until we have designs
  ($ Box
     {:sx #js {:width width
               :position "relative"
               :backgroundColor "#000"
               :fontFamily "Proxima Nova, -apple-system, BlinkMacSystemFont, system-ui, sans-serif"
               :overflow "hidden"}}

     ;; Top header section
     ($ Stack
        {:direction "row"
         :sx #js {:position "absolute"
                  :inset "0px 0px auto 0px"
                  :zIndex 10
                  :p "12px"
                  :alignItems "center"
                  :background "linear-gradient(180deg, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0) 100%)"}}
        ($ Typography
           {:sx #js {:fontSize "16px"
                     :fontWeight 600
                     :color "#fff"
                     :mr "auto"}}
           "For You")
        ($ SvgIcon
           {:component PersonCircle
            :sx #js {:color "#fff"
                     :width "24px"
                     :height "24px"
                     :mr "12px"}}))

     ;; Main content area (children - video/image)
     ($ Box
        {:sx #js {:width "100%"
                  :aspectRatio "9/16"
                  :backgroundColor "#000"}}
        children)

     ;; Right-side engagement buttons
     ($ Stack
        {:sx #js {:position "absolute"
                  :right "12px"
                  :bottom "100px"
                  :zIndex 20
                  :alignItems "center"
                  :gap "16px"}}

        ;; Profile button
        ($ Stack
           {:sx #js {:alignItems "center"}}
           ($ Avatar
              {:sx #js {:width "48px"
                        :height "48px"
                        :border "2px solid #fff"
                        :backgroundColor "#FF0050"}}
              "T"))

        ;; Like button
        ($ Stack
           {:sx #js {:alignItems "center"}}
           ($ IconButton
              {:sx #js {:p "0px"
                        :color "#fff"}}
              ($ SvgIcon
                 {:component Heart
                  :sx #js {:width "32px"
                           :height "32px"
                           :filter "drop-shadow(0 2px 4px rgba(0,0,0,0.5))"}}))
           ($ Typography
              {:sx #js {:fontSize "12px"
                        :fontWeight 600
                        :color "#fff"
                        :mt "4px"
                        :textShadow "0 2px 4px rgba(0,0,0,0.5)"}}
              "12.5K"))

        ;; Comment button
        ($ Stack
           {:sx #js {:alignItems "center"}}
           ($ IconButton
              {:sx #js {:p "0px"
                        :color "#fff"}}
              ($ SvgIcon
                 {:component BubbleLeft
                  :sx #js {:width "32px"
                           :height "32px"
                           :filter "drop-shadow(0 2px 4px rgba(0,0,0,0.5))"}}))
           ($ Typography
              {:sx #js {:fontSize "12px"
                        :fontWeight 600
                        :color "#fff"
                        :mt "4px"
                        :textShadow "0 2px 4px rgba(0,0,0,0.5)"}}
              "1,234"))

        ;; Share button
        ($ Stack
           {:sx #js {:alignItems "center"}}
           ($ IconButton
              {:sx #js {:p "0px"
                        :color "#fff"}}
              ($ SvgIcon
                 {:component ArrowTurnUpRight
                  :sx #js {:width "28px"
                           :height "28px"
                           :filter "drop-shadow(0 2px 4px rgba(0,0,0,0.5))"}}))
           ($ Typography
              {:sx #js {:fontSize "12px"
                        :fontWeight 600
                        :color "#fff"
                        :mt "4px"
                        :textShadow "0 2px 4px rgba(0,0,0,0.5)"}}
              "567"))

        ;; Bookmark button
        ($ IconButton
           {:sx #js {:p "0px"
                     :color "#fff"}}
           ($ SvgIcon
              {:component Bookmark
               :sx #js {:width "28px"
                        :height "28px"
                        :filter "drop-shadow(0 2px 4px rgba(0,0,0,0.5))"}})))

     ;; Bottom section with ad text and CTA
     ($ Stack
        {:sx #js {:position "absolute"
                  :inset "auto 0px 0px 0px"
                  :zIndex 10
                  :p "12px"
                  :pb "20px"
                  :background "linear-gradient(0deg, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0) 100%)"}}

        ;; Username
        ($ Typography
           {:sx #js {:fontSize "14px"
                     :fontWeight 700
                     :color "#fff"
                     :mb "4px"}}
           "@tiktokauser")

        ;; Ad text/caption
        ($ Typography
           {:sx #js {:fontSize "14px"
                     :color "#fff"
                     :mb "8px"
                     :lineHeight "1.4"}}
           (get-value components :urn:tiktok:ad-text))

        ;; Ad name/headline
        ($ Typography
           {:sx #js {:fontSize "13px"
                     :color "#fff"
                     :mb "12px"
                     :opacity 0.9}}
           (get-value components :urn:tiktok:ad-name))

        ;; Sponsored label
        ($ Typography
           {:sx #js {:fontSize "12px"
                     :color "#fff"
                     :mb "8px"
                     :opacity 0.8}}
           "Sponsored")

        ;; CTA Button
        ($ Button
           {:variant "contained"
            :fullWidth true
            :sx #js {:backgroundColor "#FE2C55"
                     :color "#fff"
                     :fontSize "15px"
                     :fontWeight 700
                     :textTransform "none"
                     :borderRadius "4px"
                     :py "10px"
                     :boxShadow "none"
                     "&:hover" #js {:backgroundColor "#FF1744"
                                    :boxShadow "none"}}}
           (get-value components :urn:tiktok:cta)))))

